import styled from 'styled-components';

export default styled.div`
  display: inline-block;
  min-width: 980px;
  min-height: 1200px;
  background-color: #FFF;
  text-align: center;
`;
